
import constants from 'Constants';
import sequenceService from 'SequenceService';

function getDatabaseXML(connectionID){
    return {
        xml:`<Action id="" name="New Action" type="11" active="true" connectionId="${connectionID}">
              <Send/>
              <Receive distinctResults="false"/>
              <Tables/>
            </Action>
        `,
        type: '11'
    };
}

function getDirectoryServiceXML(connectionID){
    return {
        xml:`<Action id="" name="New Action" type="21" active="true" connectionId="${connectionID}">
              <Send/>
              <Receive/>
              <DistinguishedName/>
            </Action>
        `,
        type: '21'
    };
}

function getFormXML(connectionID){
    return {
        xml:`<Action id="" name="New Action" type="40" active="true" connectionId="${connectionID}">
              <Send/>
              <Receive/>
              <Fields/>
            </Action>
        `,
        type: '40'
    };
}

function getGoogleSpreadSheetXML(connectionID){
    return {
        xml: `<Action id="" name="New Action" type="83" active="true" connectionId="${connectionID}">
              <Send/>
              <Receive/>
            </Action>
        `,
        type: '83'
    };
}

function getWebServiceXML(connectionID){
    return {
        xml:`<Action id="" name="New Action" type="30" active="true" connectionId="${connectionID}" operation="" operationUrl="" method="POST" targetNamespace="">
              <Send/>
              <Receive/>
            </Action>
        `,
        type: '30'
    };
}

function getRestServiceXML(connectionID){
    return {
        xml:`<Action id="" name="New Action" type="110" active="true" connectionId="${connectionID}" requestType="" responseType="" actionEndpoint="">
              <Send/>
              <Receive/>
            </Action>
        `,
        type: '110'
    };
}

function getTextXML(connectionID){
    return {
        xml: `<Action id="" name="New Action" type="71" active="true" connectionId="${connectionID}">
              <Send/>
              <Receive distinctResults="false"/>
            </Action>
        `,
        type: '71'
    };
}

function getVectorDBXML(connectionID){
    return {
        xml: `<Action id="" name="Query" type="120" active="true" connectionId="${connectionID}">
              <Send>
                <Parameter id="" name="userMessage" operation="0" value="userMessage" isFixed="false" fixedValue=""/>
                <Parameter id="" name="vectorDbConnectionId" operation="0" value="vectorDbConnectionId" isFixed="true" fixedValue="${connectionID}"/>
              </Send>
              <Receive>
                <Parameter id="" name="message" operation="0" value="message" isFixed="false" fixedValue=""/>
                <Parameter id="" name="supportText" operation="0" value="supportText" isFixed="false" fixedValue=""/>
                <Parameter id="" name="txtPaths" operation="0" value="txtPaths" isFixed="false" fixedValue=""/>
              </Receive>
            </Action>
        `,
        type: '120'
    };
}

const xmlHandlers = new Map();
xmlHandlers.set(constants.DATABASES_GROUP_TYPE, getDatabaseXML);
xmlHandlers.set(constants.DIRECTORY_GROUP_TYPE, getDirectoryServiceXML);
xmlHandlers.set(constants.WEB_GROUP_TYPE,  getWebServiceXML );
xmlHandlers.set(constants.REST_GROUP_TYPE,  getRestServiceXML );
xmlHandlers.set(constants.FORMS_GROUP_TYPE, getFormXML);
xmlHandlers.set(constants.GOOGLE_GROUP_TYPE, getGoogleSpreadSheetXML);
xmlHandlers.set(constants.TEXT_GROUP_TYPE, getTextXML);
xmlHandlers.set(constants.VECTORDB_GROUP_TYPE, getVectorDBXML);

export default class ActionXMLService {

    static getTemplate(connectionType, connectionID){
        return xmlHandlers.get(connectionType)(connectionID);
    }


}